// src/components/Login.js
import React, { useState, useContext } from "react";
import { Box, TextField, Button, Typography, Modal } from "@mui/material";
import { MainContext } from "../../App";
import { useAuthStore } from "../../@shared/store/useAuthStore";
import NeoButton from "../NeoButton";
import { db } from "../../@shared/firebase/config";
import Toast from "../Toast";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../@shared/firebase/config";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordResetVisible, setPasswordResetVisible] = useState(false);

  const { login } = useAuthStore();
  const {
    setSuccess,
    setError,
    setMessage,
    setInfo,
    Theme,
    gameScreenLoading,
    setGameScreenLoading,
  } = useContext(MainContext);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setGameScreenLoading(true);
      setMessage("Logging in...");
      setInfo(true);
      let res = await login(email, password);
      if (res) {
        if (res.success) {
          setMessage(res.message);
          setSuccess(true);
          setLoading(false);
        } else {
          setMessage("Login failed. Please check your credentials.");
          setError(true);
          setLoading(false);
        }
      }
    } catch (error) {
      setGameScreenLoading(false);
      setMessage("Login failed. Please check your credentials.");
      setError(true);
      setLoading(false);
    }
  };

  const sendPWResetEmail = async () => {
    try {
      setLoading(true);
      setMessage("Sending password reset email...");
      setInfo(true);
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent. Please check your inbox.");
      setSuccess(true);
      setLoading(false);
      setPasswordResetVisible(false);
      setEmail("");
    } catch (error) {
      setMessage("Failed to send password reset email.");
      setError(true);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "300px", textAlign: "center" }}>
      <Toast onFinish={() => {}} timeTilClose={2000} />
      <Typography
        variant="h5"
        sx={{ marginBottom: "1rem", fontWeight: "bold" }}
      >
        Login
      </Typography>
      <TextField
        fullWidth
        label="Email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{ marginBottom: "1rem" }}
      />
      <TextField
        fullWidth
        label="Password"
        variant="outlined"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        sx={{ marginBottom: "1rem" }}
      />
      {/* <Button
        variant="contained"
        fullWidth
        onClick={() => login(email, password)}
      >
        Login
      </Button> */}
      <NeoButton
        onClick={handleLogin}
        width={100}
        text="Login"
        color={Theme.palette.primary.main}
        disabled={!!loading}
      />
      <Typography sx={{ mt: 2 }}>
        forgot password?{" "}
        <span
          onClick={() => setPasswordResetVisible(true)}
          style={{
            color: Theme.palette.primary.main,
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: "bold",
          }}
        >
          click here
        </span>
      </Typography>

      <Modal
        open={passwordResetVisible}
        onClose={() => setPasswordResetVisible(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 360,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
            outline: "none",
          }}
        >
          <Typography variant="h6" component="h2">
            Reset Password
          </Typography>
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ marginBottom: "1rem" }}
          />
          <NeoButton
            onClick={sendPWResetEmail}
            text={"Send Email"}
            width={100}
            color={Theme.palette.primary.main}
            disabled={!!loading}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default Login;
